module.exports = __webpack_public_path__ + "static/media/20s_female_models_temp.0da522bb.jpg";